import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "drop-down-root" }
const _hoisted_2 = { class: "drop-down-label" }
const _hoisted_3 = {
  key: 0,
  class: "drop-down-list"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_arrow_l = _resolveComponent("i-arrow-l")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "drop-down-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showList = !_ctx.showList))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _createVNode(_component_i_arrow_l, {
        class: "drop-down-icon",
        color: '#854b97'
      })
    ]),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withCtx(() => [
        (_ctx.showList)
          ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (_ctx.handleListItemClick(index))
                }, _toDisplayString(_ctx.getLabel(index)), 9, _hoisted_4))
              }), 128))
            ])), [
              [_directive_click_outside, _ctx.handleClickOutside]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}